<link
    rel="stylesheet"
    href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
    integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
    crossorigin=""
/>

<section class="container-wrapper">
  <div>
    <h1 class="module-heading">{{ 'pages.list.heading' | translate }}</h1>
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="30">
      </mat-progress-spinner>
    </div>
    <div class="scrollable" *ngIf="!loading">
      <app-bciti-table
        *ngIf="requests.length > 0; else elseBlock"
        [tableData]="requests"
        [htmlProperties]="htmlProperties"
        [length]="pageOptions.length"
        [pageIndex]="pageOptions.page"
        [pageSize]="pageOptions.pageSize"
        routerLinkActive="router-link-active"
        [columnHeader]="columnHeaders"
        [actionMenuData]="actionMenu"
        (page)="pageChange($event)"
        (actions)="handleActions($event)">
      </app-bciti-table>
      <ng-template #elseBlock>
        <p>{{ 'pages.list.table.no-data' | translate }}</p>
      </ng-template>
    </div>
  </div>
</section>